module.exports = __webpack_public_path__ + "media/images/thumbs/physanims/a7-6-9b2be25aa61ba5cc296c5f30233eeedb.jpg";